import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeleteHelperService {
  private readonly delete = new BehaviorSubject<boolean>(false);

  get flag(): boolean {
    return this.delete.getValue();
  }

  set flag(flag: boolean) {
    this.delete.next(flag);
  }
}
